module.exports = __webpack_public_path__ + "static/media/5DPO11.9854ad80.jpg";